import React from 'react';
const ClubStickyFooterSm = ({ ...r }) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 408 98" {...r}>
            <path d="M48 0h360v96H48z"></path>
            <g
                stroke="#fff"
                strokeLinecap="square"
                strokeWidth="0.5"
                clipPath="url(#banner-a)"
            >
                <path d="M376 24l16 8m-16 0l16 8m-16 0l16 8m-16 0l16 8m-16 0l16 8"></path>
            </g>
            <path
                fill="url(#banner-b)"
                fillOpacity="0.7"
                fillRule="evenodd"
                d="M107.52 0h107.52L107.52 96H0L107.52 0z"
                clipRule="evenodd"
            ></path>
            <path
                fill="url(#banner-c)"
                fillOpacity="0.8"
                fillRule="evenodd"
                d="M155.52 0h69.12L123.67 90.152A23.02 23.02 0 01108.34 96c-21.14 0-31.1-26.108-15.33-40.187L155.52 0z"
                clipRule="evenodd"
            ></path>
            <path
                fill="url(#banner-d)"
                fillOpacity="0.8"
                fillRule="evenodd"
                d="M208.49 5.848A23.02 23.02 0 01223.82 0c21.14 0 31.1 26.108 15.33 40.187l-55.96 49.965A23.02 23.02 0 01167.86 96c-21.14 0-31.099-26.108-15.33-40.187l55.96-49.965z"
                clipRule="evenodd"
            ></path>
            <path
                fill="#fff"
                d="M224.698 94.94a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364-6.365a1.5 1.5 0 102.12 2.122 1.5 1.5 0 00-2.12-2.122zm-6.364 6.365a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm0-12.728a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364 6.363a1.5 1.5 0 102.12 2.122 1.5 1.5 0 00-2.12-2.122zm-6.364 6.365a1.501 1.501 0 002.122 2.12 1.501 1.501 0 00-2.122-2.12zm6.364-19.092a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364-6.364a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm0 12.728a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364-6.364a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm0 12.727a1.5 1.5 0 102.12 2.122 1.5 1.5 0 00-2.12-2.122zm-6.364-6.363a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm0 12.728a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364-6.365a1.5 1.5 0 102.12 2.122 1.5 1.5 0 00-2.12-2.122zm-6.364 6.365a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm19.092-31.82a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364 6.364a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364 6.364a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364 6.364a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12zm-6.364 6.363a1.5 1.5 0 102.12 2.122 1.5 1.5 0 00-2.12-2.122zm-6.364 6.365a1.5 1.5 0 102.12 2.12 1.5 1.5 0 00-2.12-2.12z"
                opacity="0.5"
            ></path>
            <defs>
                <linearGradient
                    id="banner-b"
                    x1="983.955"
                    x2="-157.589"
                    y1="41.456"
                    y2="84.223"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <linearGradient
                    id="banner-c"
                    x1="535.05"
                    x2="17.151"
                    y1="39.22"
                    y2="77.83"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <linearGradient
                    id="banner-d"
                    x1="594.57"
                    x2="81.745"
                    y1="31.446"
                    y2="103.529"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="#fff" stopOpacity="0.5"></stop>
                    <stop offset="1" stopColor="#fff" stopOpacity="0"></stop>
                </linearGradient>
                <clipPath id="banner-a">
                    <path
                        fill="#fff"
                        d="M0 0h16v40H0z"
                        transform="translate(376 24)"
                    ></path>
                </clipPath>
            </defs>
        </svg>
    );
}

export default ClubStickyFooterSm;